// Calls to VERA's control plane with the signed-in person's Microsoft token.

import { config } from "../config/env";
import { L } from "./i18n";

export async function cpFetch<T>(getToken: () => Promise<string | null>, path: string, init: RequestInit = {}): Promise<T> {
  const token = await getToken();
  if (!token) throw new Error(L("Please sign in again.", "Të lutem hyr përsëri."));
  const res = await fetch(`${config.controlPlaneUrl}${path}`, {
    ...init,
    headers: { ...(init.body ? { "Content-Type": "application/json" } : {}), ...(init.headers ?? {}), Authorization: `Bearer ${token}` },
  });
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new Error(data.error || (res.status === 401 ? L("Please sign in again.", "Të lutem hyr përsëri.") : L("VERA is unavailable right now. Please try again.", "VERA nuk është e disponueshme tani. Të lutem provo përsëri.")));
  return data;
}
